/* eslint-disable */

// Mixins

import container from '@/mixins/container.js'
import displayObject from '@/mixins/display-object.js'
import ecsContainer from '@/mixins/ecs-container.js'
import sprite from '@/mixins/sprite.js'
import updateTick from '@/mixins/update-tick.js'

export const mixins = {
  container,
  displayObject,
  ecsContainer,
  sprite,
  updateTick
}

// Components

import Collisions from '@/components/Collisions.vue'
import Container from '@/components/Container.vue'
import KeyboardInput from '@/components/KeyboardInput.vue'
import Renderer from '@/components/Renderer.vue'
import Sprite from '@/components/Sprite.vue'
import Vame from '@/components/Vame.vue'

export const components = {
  Collisions,
  Container,
  KeyboardInput,
  Renderer,
  Sprite,
  Vame
}

// Store

import Component from '@/store/Component.js'
import createStore from '@/store/create-store.js'
import createEntity from '@/store/create-entity.js'

// Store components
import Collide from '@/store/components/Collide.js'
import Render from '@/store/components/Render.js'

export const store = {
  Component,
  createStore,
  createEntity,

  components: {
    Collide,
    Render
  }
}
